import { firestore } from '../firebase'
import {
  ON_ORDERS_CHANGE,
  REQUEST_ORDERS
} from './types'

import {createClient} from './clients'
import {createProduct} from './products'
import {idNumber, billNumber} from '../share/id_helper'

const onOrdersChange = (updates) => ({ type: ON_ORDERS_CHANGE, updates })
const requestOrders = () => ({type: REQUEST_ORDERS})

export const listenForOrdersChanges = () =>
  (dispatch, getState) => {
    const account = getState().account

    if(!account || !account.currentAccountId) throw new Error("Unknown Account")

    dispatch(requestOrders())
    return firestore.collection('accounts').doc(account.currentAccountId)
      .collection('orders')
      .orderBy('createdAt','desc')
      .onSnapshot( snapshot => {
        const updates = { added: [], removed: [], modified: [] }

        snapshot.docChanges().forEach( change => {
          if(updates[change.type]) updates[change.type].push(
            {...change.doc.data(), id:change.doc.id}
          )
        })

        dispatch(onOrdersChange(updates))
      }, error => console.log('ERROR:::::',error))
  }

export const createOrder = (data) =>
  (dispatch, getState) => {
    const state = getState()

    if(!state.account || !state.account.currentAccountId) return
    const order = {...data, items: data.items.slice(), createdAt: Date.now()}

    // create client from order
    return dispatch(createClient({name: order.client, address: order.address}))
      // then add client data to order
      .then(client => (
        {...order, clientId: client.id, clientNumber: client.number}
      ))
      // then create products and extend order product data
      .then(order =>
        Promise.all(order.items.map(
          item => dispatch(createProduct({name: item.product, price: item.price}))
        )).then(products => {
          products.forEach((product,index) => {
            order.items[index] = {...order.items[index],
              productId: product.id, productNumber: product.number
            }
          })
          return order
        })
      )
      // create order number. That's important for the bill
      .then(order =>
        firestore.collection('accounts')
                 .doc(state.account.currentAccountId)
                 .collection('orders')
                 //.where("date",">=",thisYear.getTime())
                 .orderBy("createdAt", "desc")
                 .limit(1)
                 .get().then(querySnapshots => {
                   let count = 1
                   querySnapshots.forEach((doc) => {
                     count = ((doc.data() || {}).count || 0)+1
                   })
                   order.count = count
                   return order
                 })
      // finaly create the order
      ).then(order => {
        // then create order with a reference to the client
        const newOrderRef = firestore.collection('accounts')
                                     .doc(state.account.currentAccountId)
                                     .collection('orders')
                                     .doc()
        order.id = newOrderRef.id
        order.number = billNumber(order)

        return newOrderRef.set(order).then(() => order)
      })
  }


export const updateOrder = (order) =>
  (dispatch, getState) => {
    const account = getState().account
    if(!account || !account.currentAccountId) return
    return firestore.collection('accounts')
                    .doc(account.currentAccountId)
                    .collection('orders')
                    .doc(order.id)
                    .set(order,{ merge: true })
  }



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/actions/orders.js